import React from 'react';
import classes from './Notification.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCircleCheck, faCircleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';

export enum NotificationStatus {
    Search = "Searching...",
    Save = "Saving...",
    Update = "Updating...",
    Error = "Error!",
    Success = "Success!",
    Http = "Http"
}

export type NotificationProps = {
    title: string | null,
    status: string | null,
    message: string | null
}

const Notification = (props: NotificationProps) => {
    let specialClasses = '';

    if (props.status === 'Error') {
        specialClasses = classes.error;
    }

    if (props.status === 'Success') {
        specialClasses = classes.success;
    }

    if (props.status === 'Http') {
        specialClasses = classes.info;
    }

    const cssClasses = `${classes.notification} ${specialClasses}`;
    const icon = () => {
        switch (props.status) {
            case NotificationStatus.Search:
            case NotificationStatus.Save:
            case NotificationStatus.Update:
                return faSpinner;
            case NotificationStatus.Error:
                return faCircleExclamation;
            case NotificationStatus.Http:
                return faXmark;
            default:
                return faCircleCheck;
        }
    }

    const spinnerClass = () => {
        switch (props.status) {
            case NotificationStatus.Search:
            case NotificationStatus.Save:
            case NotificationStatus.Update:
                return classes.spinner;
            default:
                return '';
        }
    }

    return (
        <section className={cssClasses}>
            <FontAwesomeIcon icon={icon()} className={spinnerClass()} size="2x"/>
            <h2>{props.status}</h2>
            <p>{props.message}</p>
        </section>
    );
};

export default Notification;